import React, { useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Divider,
  Paper,
  List,
  ListItem,
  ListItemText
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import "../../../styles/CustomerDashboard.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerDashboardDataRequest } from "../../../redux/Dashboard/DashboardAction";
import { formatDatetimeWithAMPM } from "../../../Style";
const CustomerDashBoard = () => {
  const dispatch = useDispatch();
  const { customerData, loading, error } = useSelector(
    (state) => state.dashboard
  );

  useEffect(() => {
    dispatch(fetchCustomerDashboardDataRequest());
  }, [dispatch]);

  console.log(customerData);

  const upcomingBookings = customerData?.servicebookings?.filter((booking) => {
    const departureDate = booking?.BookingDetail?.date_of_departure
      ? new Date(booking?.BookingDetail?.date_of_departure)
      : null;
    const arrivalDate = booking?.BookingDetail?.date_of_arrival
      ? new Date(booking?.BookingDetail?.date_of_arrival)
      : null;
    const currentDate = new Date();

    return (
      (departureDate && departureDate > currentDate) ||
      (arrivalDate && arrivalDate > currentDate)
    );
  });

  const serviceHistory = customerData?.servicebookings?.filter(
    (booking) => booking?.status === 1 || booking?.status === 3
  );

  return (
    <Box className="container">
      <Grid container spacing={3} className="bottom-spacing">
        {/* Total Bookings */}
        <Grid item xs={12} sm={4}>
          <Paper className="paper-card">
            <CalendarTodayIcon className="icon-blue" />
            <Box>
              <Typography variant="h6" className="text-blue-heading">
                Total Bookings
              </Typography>
              <Typography variant="h4" className="text-blue-value">
                {customerData?.count?.totalBookingCount}
              </Typography>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Paper className="paper-card">
            <AssignmentTurnedInIcon className="icon-green" />
            <Box>
              <Typography variant="h6" className="text-green-heading">
                Completed Bookings
              </Typography>
              <Typography variant="h4" className="text-green-value">
                {customerData?.count?.totalCompletedBookingCount}
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper className="paper-card">
            <EventAvailableIcon className="icon-red" />
            <Box>
              <Typography variant="h6" className="text-red-heading">
                Cancelled Bookings
              </Typography>
              <Typography variant="h4" className="text-red-value">
                {customerData?.count?.totalCancelBookingCount}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
      {/* Upcoming Bookings Section */}
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Card className="card">
            <CardContent>
              <Typography variant="h5" className="heading">
                Upcoming Bookings
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Box className="list-container">
                <List>
                  {upcomingBookings?.length > 0 ? (
                    upcomingBookings.map((booking) => (
                      <ListItem key={booking.id} className="list-item">
                        <ListItemText
                          primary={`${booking.booking_serial_no} - ${booking.Airport.name}`}
                          secondary={
                            booking.BookingDetail.date_of_departure &&
                            booking.BookingDetail.date_of_arrival
                              ? `Departure: ${booking.BookingDetail.date_of_departure} at ${booking.BookingDetail.time_of_departure} | Arrival: ${booking.BookingDetail.date_of_arrival} at ${booking.BookingDetail.time_of_arrival}`
                              : booking.BookingDetail.date_of_departure
                              ? `Departure: ${booking.BookingDetail.date_of_departure} at ${booking.BookingDetail.time_of_departure}`
                              : booking.BookingDetail.date_of_arrival
                              ? `Arrival: ${booking.BookingDetail.date_of_arrival} at ${booking.BookingDetail.time_of_arrival}`
                              : "No travel details available"
                          }
                        />
                        {/* <Button variant="contained" className="orange-button">
                          Manage
                        </Button> */}
                      </ListItem>
                    ))
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No upcoming bookings found.
                    </Typography>
                  )}
                </List>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        {/* Service History Section */}
        <Grid item xs={12} sm={6}>
          <Card className="card">
            <CardContent>
              <Typography variant="h5" className="heading">
                Service History
              </Typography>
              <Divider sx={{ mb: 3 }} />
              <Box className="list-container">
                {serviceHistory?.length > 0 ? (
                  serviceHistory.map((booking) => {
                    const formattedDate = formatDatetimeWithAMPM(
                      booking.Service.created_at
                    );
                    return (
                      <Box key={booking.service_id} className="service-box">
                        <Box>
                          <Typography variant="h6">
                            {booking.Service.services}
                          </Typography>
                          <Typography variant="body2">
                            Date: {formattedDate}
                          </Typography>
                        </Box>
                        {booking.Service.status === 1 ? (
                          <AssignmentTurnedInIcon className="icon-green" />
                        ) : (
                          <EventAvailableIcon className="icon-red" />
                        )}
                      </Box>
                    );
                  })
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No Services found.
                  </Typography>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
export default CustomerDashBoard;
